import { documentToPlainTextString } from "@contentful/rich-text-plain-text-renderer"

const Embed = ({ data }) => {
    const text = documentToPlainTextString(data)
    if (!text) return
    const iframe = text.replace(/<iframe/gi, '<iframe loading="lazy"')
    return <div style={{margin: '20px 0 40px'}} dangerouslySetInnerHTML={{__html: iframe}} />
}

export default Embed